var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:{'is-secondary': _vm.progress === 'in-progress', 'is-danger': _vm.progress === 'failed', 'is-success': _vm.progress === 'completed'}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }